__turbopack_context__.v({
  "button2": "PlasmicContactModalForm-module__vL7E1G__button2",
  "company": "PlasmicContactModalForm-module__vL7E1G__company",
  "contactForm": "PlasmicContactModalForm-module__vL7E1G__contactForm",
  "desc": "PlasmicContactModalForm-module__vL7E1G__desc",
  "desc2": "PlasmicContactModalForm-module__vL7E1G__desc2",
  "desc3": "PlasmicContactModalForm-module__vL7E1G__desc3",
  "desc4": "PlasmicContactModalForm-module__vL7E1G__desc4",
  "desc5": "PlasmicContactModalForm-module__vL7E1G__desc5",
  "desc6": "PlasmicContactModalForm-module__vL7E1G__desc6",
  "desc7": "PlasmicContactModalForm-module__vL7E1G__desc7",
  "desc8": "PlasmicContactModalForm-module__vL7E1G__desc8",
  "desc9": "PlasmicContactModalForm-module__vL7E1G__desc9",
  "dialogClose": "PlasmicContactModalForm-module__vL7E1G__dialogClose",
  "email": "PlasmicContactModalForm-module__vL7E1G__email",
  "emailErrorContainer": "PlasmicContactModalForm-module__vL7E1G__emailErrorContainer",
  "emailInput": "PlasmicContactModalForm-module__vL7E1G__emailInput",
  "emailLabel": "PlasmicContactModalForm-module__vL7E1G__emailLabel",
  "emailProvider": "PlasmicContactModalForm-module__vL7E1G__emailProvider",
  "error": "PlasmicContactModalForm-module__vL7E1G__error",
  "error2": "PlasmicContactModalForm-module__vL7E1G__error2",
  "error3": "PlasmicContactModalForm-module__vL7E1G__error3",
  "error5": "PlasmicContactModalForm-module__vL7E1G__error5",
  "error6": "PlasmicContactModalForm-module__vL7E1G__error6",
  "fill": "PlasmicContactModalForm-module__vL7E1G__fill",
  "footer": "PlasmicContactModalForm-module__vL7E1G__footer",
  "form": "PlasmicContactModalForm-module__vL7E1G__form",
  "formModal": "PlasmicContactModalForm-module__vL7E1G__formModal",
  "header": "PlasmicContactModalForm-module__vL7E1G__header",
  "icon2": "PlasmicContactModalForm-module__vL7E1G__icon2",
  "icon3": "PlasmicContactModalForm-module__vL7E1G__icon3",
  "icon4": "PlasmicContactModalForm-module__vL7E1G__icon4",
  "icon5": "PlasmicContactModalForm-module__vL7E1G__icon5",
  "img__guQs": "PlasmicContactModalForm-module__vL7E1G__img__guQs",
  "img__onE5R": "PlasmicContactModalForm-module__vL7E1G__img__onE5R",
  "img__pwiLs": "PlasmicContactModalForm-module__vL7E1G__img__pwiLs",
  "inputsRow": "PlasmicContactModalForm-module__vL7E1G__inputsRow",
  "institution": "PlasmicContactModalForm-module__vL7E1G__institution",
  "institutionErrorContainer": "PlasmicContactModalForm-module__vL7E1G__institutionErrorContainer",
  "institutionInput": "PlasmicContactModalForm-module__vL7E1G__institutionInput",
  "institutionLabels": "PlasmicContactModalForm-module__vL7E1G__institutionLabels",
  "institutionPhoneCol": "PlasmicContactModalForm-module__vL7E1G__institutionPhoneCol",
  "institutionProvider": "PlasmicContactModalForm-module__vL7E1G__institutionProvider",
  "intro": "PlasmicContactModalForm-module__vL7E1G__intro",
  "label10": "PlasmicContactModalForm-module__vL7E1G__label10",
  "label4": "PlasmicContactModalForm-module__vL7E1G__label4",
  "label5": "PlasmicContactModalForm-module__vL7E1G__label5",
  "label6": "PlasmicContactModalForm-module__vL7E1G__label6",
  "label7": "PlasmicContactModalForm-module__vL7E1G__label7",
  "label8": "PlasmicContactModalForm-module__vL7E1G__label8",
  "layout112": "PlasmicContactModalForm-module__vL7E1G__layout112",
  "left": "PlasmicContactModalForm-module__vL7E1G__left",
  "link": "PlasmicContactModalForm-module__vL7E1G__link",
  "link__bzIj5": "PlasmicContactModalForm-module__vL7E1G__link__bzIj5",
  "link__flqLt": "PlasmicContactModalForm-module__vL7E1G__link__flqLt",
  "link__go6Jr": "PlasmicContactModalForm-module__vL7E1G__link__go6Jr",
  "link__kugEl": "PlasmicContactModalForm-module__vL7E1G__link__kugEl",
  "link__mliyE": "PlasmicContactModalForm-module__vL7E1G__link__mliyE",
  "link__qvVkD": "PlasmicContactModalForm-module__vL7E1G__link__qvVkD",
  "link__rtLxE": "PlasmicContactModalForm-module__vL7E1G__link__rtLxE",
  "message": "PlasmicContactModalForm-module__vL7E1G__message",
  "messageErrorContainer": "PlasmicContactModalForm-module__vL7E1G__messageErrorContainer",
  "messageLabel": "PlasmicContactModalForm-module__vL7E1G__messageLabel",
  "messageProvider": "PlasmicContactModalForm-module__vL7E1G__messageProvider",
  "messageTextarea": "PlasmicContactModalForm-module__vL7E1G__messageTextarea",
  "modalCloseButton": "PlasmicContactModalForm-module__vL7E1G__modalCloseButton",
  "name": "PlasmicContactModalForm-module__vL7E1G__name",
  "nameErrorContainer": "PlasmicContactModalForm-module__vL7E1G__nameErrorContainer",
  "nameInput": "PlasmicContactModalForm-module__vL7E1G__nameInput",
  "nameLabel": "PlasmicContactModalForm-module__vL7E1G__nameLabel",
  "nameProvider": "PlasmicContactModalForm-module__vL7E1G__nameProvider",
  "nameWorkCol": "PlasmicContactModalForm-module__vL7E1G__nameWorkCol",
  "paragraph": "PlasmicContactModalForm-module__vL7E1G__paragraph",
  "paragraph2": "PlasmicContactModalForm-module__vL7E1G__paragraph2",
  "paragraph3": "PlasmicContactModalForm-module__vL7E1G__paragraph3",
  "phone": "PlasmicContactModalForm-module__vL7E1G__phone",
  "phoneErrorContainer": "PlasmicContactModalForm-module__vL7E1G__phoneErrorContainer",
  "phoneInput": "PlasmicContactModalForm-module__vL7E1G__phoneInput",
  "phoneProvider": "PlasmicContactModalForm-module__vL7E1G__phoneProvider",
  "sales": "PlasmicContactModalForm-module__vL7E1G__sales",
  "send": "PlasmicContactModalForm-module__vL7E1G__send",
  "sendMessageBtn": "PlasmicContactModalForm-module__vL7E1G__sendMessageBtn",
  "spinnerIcon": "PlasmicContactModalForm-module__vL7E1G__spinnerIcon",
  "support": "PlasmicContactModalForm-module__vL7E1G__support",
  "svg___7GFtB": "PlasmicContactModalForm-module__vL7E1G__svg___7GFtB",
  "svg__bIMws": "PlasmicContactModalForm-module__vL7E1G__svg__bIMws",
  "svg__cjTlV": "PlasmicContactModalForm-module__vL7E1G__svg__cjTlV",
  "svg__gw4Rc": "PlasmicContactModalForm-module__vL7E1G__svg__gw4Rc",
  "svg__nwEcm": "PlasmicContactModalForm-module__vL7E1G__svg__nwEcm",
  "svg__osSyw": "PlasmicContactModalForm-module__vL7E1G__svg__osSyw",
  "svg__pIs5C": "PlasmicContactModalForm-module__vL7E1G__svg__pIs5C",
  "svg__qsDjn": "PlasmicContactModalForm-module__vL7E1G__svg__qsDjn",
  "svg__zwRad": "PlasmicContactModalForm-module__vL7E1G__svg__zwRad",
  "text": "PlasmicContactModalForm-module__vL7E1G__text",
  "text8": "PlasmicContactModalForm-module__vL7E1G__text8",
  "text9": "PlasmicContactModalForm-module__vL7E1G__text9",
  "text___2ZFhw": "PlasmicContactModalForm-module__vL7E1G__text___2ZFhw",
  "text__invbI": "PlasmicContactModalForm-module__vL7E1G__text__invbI",
  "title": "PlasmicContactModalForm-module__vL7E1G__title",
  "title2": "PlasmicContactModalForm-module__vL7E1G__title2",
  "title4": "PlasmicContactModalForm-module__vL7E1G__title4",
  "title5": "PlasmicContactModalForm-module__vL7E1G__title5",
  "top": "PlasmicContactModalForm-module__vL7E1G__top",
});
